export default {
      id: "ic_filter_check-usage",
      viewBox: "0 0 24 24",
      url: "/" + "images/icons.3.109.2.svg#ic_filter_check-usage",
      toString: function () {
        return this.url;
      }
    }